import MonetaryFormatter from '~/app/helper/MonetaryFormatter';
import Vue from 'vue';

const formatter = new MonetaryFormatter();

Vue.filter('currency', function(price, currencySignHtml = false, noCurrencySign = false, noDecimals = false) {

    let currencySign = App.activeCurrency;

    if (price === 'N / A') {
        return price;
    }

    if(noCurrencySign) {
        currencySign = '';
    }else if(currencySignHtml){
        currencySign = '<span class="currency__wrapper">'+currencySign+'</span>';
    }

    return formatter.format(parseFloat(price), currencySign, noDecimals);
});
